import { toastStore } from "@/store/toastStore";
import Toast from "./Toast";

/**
 * トースト一覧 コンポーネント
 * @param props props
 * @returns トースト一覧コンポーネント
 */
export default function ToastList() {
	const { toasts } = toastStore();
	return toasts.map((value) => <Toast key={value.id} value={value} />);
}
